import ConfirmBox from "../../components/boxes/ConfirmBox";
import XsCont from "../../components/containers/Xs";
import { API_URL } from "../../consts/ApiUrl";
import { validationMessage } from "../../consts/ValidationMessage";
import { Box, Button, TextField, Typography } from "@mui/material";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

type PhoneNumConfirmStepProps = {
  onPrev: () => void;
  onNext: () => void;
  requestId: string;
};

const PhoneNumConfirmStep: FC<PhoneNumConfirmStepProps> = ({
  onPrev,
  onNext,
  requestId,
}) => {
  const [form, setForm] = useState({ confirmationCode: "" });
  const [errors, setErrors] = useState({ confirmationCode: "" });
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate: () => boolean = (): boolean => {
    const newErrors = { confirmationCode: "" };
    let isValid: boolean = true;
    if (!form.confirmationCode.trim()) {
      newErrors.confirmationCode = `認証コード${validationMessage.REQUIRED}`;
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit: () => Promise<void> = async (): Promise<void> => {
    if (!validate()) return;
    try {
      const response: Response = await fetch(API_URL.VERIFY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authentication: sessionStorage.getItem("idToken") || "",
        },
        body: JSON.stringify({
          mode: "check",
          code: form.confirmationCode,
          request_id: requestId,
        }),
      });

      if (response.ok) {
        onNext();
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          confirmationCode: "認証に失敗しました。",
        }));
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };

  const handleBack: () => void = (): void => {
    onPrev();
  };

  return (
    <XsCont>
      <ConfirmBox>
        <Box mt={2} mb={3} textAlign="center">
          <Typography variant="h5" gutterBottom>
            認証コード入力
          </Typography>
        </Box>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body2">
            入力された電話番号にSMSを送信しました。
            <br />
            SMSをご確認の上認証コードを入力してください。
          </Typography>
        </Box>
        <TextField
          label="認証コード"
          name="confirmationCode"
          value={form.confirmationCode}
          onChange={handleChange}
          error={!!errors.confirmationCode}
          helperText={errors.confirmationCode}
          variant="outlined"
          required
          fullWidth
          sx={{ maxWidth: "320px", marginTop: "5px" }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit}
          sx={{ maxWidth: "320px", marginTop: "15px" }}
        >
          認証
        </Button>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={handleBack}
          sx={{ maxWidth: "320px", marginTop: "3px", marginBottom: "20px" }}
        >
          戻る
        </Button>
        <Typography variant="body2">
          ※認証コードの有効期限は15分です。
          <br />
          認証されない場合自動で再送されます。
        </Typography>
      </ConfirmBox>
    </XsCont>
  );
};

export default PhoneNumConfirmStep;
